import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  HostListener,
  ViewChildren,
  ElementRef,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderModel, BellOrders } from 'src/app/store/order/model';

enum NotificationForOrdersType {
  estimate,
  agreement,
  message,
  info,
}

class NotificationsPage {
  constructor(
    public caption: string,
    public imgPath: string,
    public pageIndex: NotificationForOrdersType,
    public orders: OrderModel[]
  ) {}
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: false,
})
export class NotificationsComponent implements OnInit, OnChanges {
  translate = inject(TranslateService);

  @Input('bellOrders') public bellOrders: BellOrders;
  @Output('onClose') public onClose = new EventEmitter();

  public pages: NotificationsPage[];
  public activePage: NotificationsPage;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bellOrders) {
      this.pages = [];

      if (this.getOrderForPage(NotificationForOrdersType.estimate)?.length > 0) {
        this.pages.push(
          new NotificationsPage(
            this.translate.instant('NOTIFICATIONS_TOOLBAR_ESTIMATE'),
            '/assets/images/icon_estimate.png',
            NotificationForOrdersType.estimate,
            this.getOrderForPage(NotificationForOrdersType.estimate)
          )
        );
      }
      if (this.getOrderForPage(NotificationForOrdersType.agreement)?.length > 0 && false) {
        this.pages.push(
          new NotificationsPage(
            this.translate.instant('NOTIFICATIONS_TOOLBAR_APPROVE'),
            '/assets/images/icon_agreement.png',
            NotificationForOrdersType.agreement,
            this.getOrderForPage(NotificationForOrdersType.agreement)
          )
        );
      }
      if (this.getOrderForPage(NotificationForOrdersType.message)?.length > 0 && false) {
        this.pages.push(
          new NotificationsPage(
            this.translate.instant('NOTIFICATIONS_TOOLBAR_MESSAGE'),
            '/assets/images/icon_message.png',
            NotificationForOrdersType.message,
            this.getOrderForPage(NotificationForOrdersType.message)
          )
        );
      }
      // new NotificationsPage(this.translate.instant('NOTIFICATIONS_TOOLBAR_INFO'), '/assets/images/icon_info.png', NotificationsPageIndex.info, this.getOrderForPage(NotificationsPageIndex.info))

      this.activePage = this.pages.find(page => page.pageIndex === NotificationForOrdersType.estimate);
    }
  }

  private getOrderForPage(pageIndex: NotificationForOrdersType): OrderModel[] {
    return this.bellOrders ? this.bellOrders[NotificationForOrdersType[pageIndex]] : [];
  }

  public setActivePage(page: NotificationsPage) {
    if (this.activePage?.pageIndex != page.pageIndex) {
      this.activePage = page;
    }
  }

  public closeClick() {
    this.onClose.emit();
  }
}
